import { createIcon } from "@chakra-ui/icons";

export default createIcon({
  displayName: "EV Charging Station",
  viewBox: "0 0 448 512",
  path: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
      fill="none"
      focusable="false"
    >
      <circle cx={15} cy={15} r={14} fill="url(#a)" />
      <g clipPath="url(#b)">
        <path
          fill="#1E40AF"
          d="M9 7c-1.103 0-2 .897-2 2v12a.999.999 0 1 0 0 2h9a.999.999 0 1 0 0-2v-4.5h.5c.69 0 1.25.56 1.25 1.25v1A2.249 2.249 0 0 0 20 21a2.249 2.249 0 0 0 2.25-2.25v-3.866A2.499 2.499 0 0 0 24 12.5v-1c0-.275-.225-.5-.5-.5H23V9.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5V11h-1V9.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5V11h-.5c-.275 0-.5.225-.5.5v1c0 1.119.734 2.066 1.75 2.384v3.866c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-1A2.75 2.75 0 0 0 16.5 15H16V9c0-1.103-.897-2-2-2H9Zm3.778 2.584c.188.125.266.36.197.572l-.781 2.34H14c.21 0 .397.132.469.326a.502.502 0 0 1-.144.553l-3.5 3a.498.498 0 0 1-.603.034.506.506 0 0 1-.197-.571l.781-2.341H9a.501.501 0 0 1-.469-.325.502.502 0 0 1 .144-.553l3.5-3a.498.498 0 0 1 .603-.035Z"
        />
      </g>
      <defs>
        <linearGradient
          id="a"
          x1={1}
          x2={29.645}
          y1={9.54}
          y2={12.084}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD52A" />
          <stop offset={1} stopColor="#FFFC49" />
        </linearGradient>
        <clipPath id="b">
          <path fill="#fff" d="M6 7h18v16H6z" />
        </clipPath>
      </defs>
    </svg>
  ),
});
